import { useState } from "react";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import MapPreview from "../mapPreview/MapPreview";
import ForecastTimeline from "../forecastTimeline/ForecastTimeline";
import "./RiskMapPreview.css";
 
const RiskMapPreview = ({ title, liveLabel }) => {
  const [forecastOffset, setForecastOffset] = useState(0);
 
  return (
<div className="risk-map-preview">
<div className="risk-map-preview-bar">
<div className="risk-map-preview-title-group">
<span className="risk-map-preview-title">
            Carte interactive
 
</span>
<span className="risk-map-preview-live">(Situation en ce moment)</span>
</div>
 
        <a
          href="/notifications"
          target="_blank"
          rel="noopener noreferrer"
          className="risk-map-expand-btn"
>
<OpenInFullIcon fontSize="inherit" />
          Étendre
</a>
</div>
 
      <div className="risk-map-preview-map">
<MapPreview forecastOffset={forecastOffset} />
 
        <div className="risk-map-preview-timeline-overlay">
<ForecastTimeline
            forecastOffset={forecastOffset}
            setForecastOffset={setForecastOffset}
          />
</div>
</div>
 
      <div className="risk-map-preview-legend">
<span className="legend-item legend-faible">■ Faible</span>
<span className="legend-item legend-modere">■ Modéré</span>
<span className="legend-item legend-eleve">■ Élevé</span>
<span className="legend-item legend-tres-eleve">■ Très élevé</span>
</div>
</div>
  );
};
 
export default RiskMapPreview;